<template>
  <BAutocomplete
    ref="autocomplete"
    v-bind="$attrs"
    label="Тег файла"
    item-text="name"
    item-value="id"
    no-data-text="Тег не найден"
    :request="request"
    v-on="$listeners"
  />
</template>

<script>
import { openApiMixin } from './mixins'
import { FilesApi } from '@/api/resources'

import BAutocomplete from '../BAutocomplete.vue'


export default {
  name: 'BAutocompleteFileTag',
  components: {
    BAutocomplete,
  },
  mixins: [
    openApiMixin,
  ],
  data: () => ({
    list: void 0,
  }),
  created() {
    const api = new FilesApi()
    this.api = api
  },
  methods: {
    async request(...args) {
      if (!this.list) {
        const { data } = await this.api.getTags(...args)
        this.list = data // .map((id) => ({ id, name: id }))
      }
      return { data: this.list, meta: { count: this.list.length } }
    },
  },
}
</script>
